import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { ModalForm } from "components/ModalForm/ModalForm";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { InputTypes } from "types/enum";
import { ICON_TYPE } from "utils/constants";
import { trans } from "utils/helpers";
import { ColumnEditModal } from "./components/ColumnEditModal/ColumnEditModal";
import { DataGridDataEntry } from "./components/DataGridDataEntry";
import "./style.scss";
import { DateObject } from "react-multi-date-picker";


interface SimpleGridPropsType {
  theadData: any[];
  theadLength: number;
  tbodyData: any[];
  tbodyLength: number;
  minCellWidth?: number;
  selectedRowObjectCallback?: (obj: any, index: number, event: any) => void;
  handleDataGridFields?: (data: any) => void;
  handleRowsData?: (data: any) => void;
  rowSelected?: any;
  mode?: any;
  DynamicObj?: any;
  disabled?: boolean;
  resizeOption?: boolean;
  showSetting?: boolean;
  dataEntry?:boolean
  createTableInDataCollectionTab?:boolean
}

export const SimpleGrid: React.FC<SimpleGridPropsType> = React.memo(
  ({
    theadData,
    theadLength,
    tbodyData,
    tbodyLength,
    minCellWidth = 30,
    selectedRowObjectCallback,
    handleDataGridFields,
    handleRowsData,
    rowSelected,
    mode,
    DynamicObj,
createTableInDataCollectionTab=false,
    disabled = false,
    resizeOption = true,
    showSetting = false,
    dataEntry=false
  }) => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const [thead, setThead] = useState<any[]>([]);
    const [tbody, setTbody] = useState<any[]>(tbodyData);
    const [showEditModal, setShowEditModal] = useState(false);
    const [operationPosition, setOperationPosition] = useState<any>(0);
    const [currentOperation, setCurrentOperation] = useState(-1);
    const [showOperations, setShowOperations] = useState(false);
    const showOptionsRow=!window.location.href.includes('form-builder')
    const [showDataGridDataEntry, setshowDataGridDataEntry] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [editedRow,setEditedRow]=useState<any>({})
    const theadLengthVal=theadLength
    const theadDataLengthVal=theadData.length
    const [EntryMode,setEntryMode]=useState('create')
    const [selectedColumn, setSelectedColumn] = useState<{
      index: number;
      title: string;
      type: string;
      typeName: string;
      label: string;
      SystemKey: string;
      icon: any;
      backendType: string;
      Formula: string;
      Keywords?: any;
    } | null>(null);
    const activeIndexRef = useRef<number | null>(activeIndex);
    const tableElement = useRef<HTMLTableElement | null>(null);
    const myStateRef = useRef<number>(-2);
    const trRef = useRef<any>();
    const [operationSubIndex, setOperationSubIndex] = useState<any>(-2);
    let tableHeight = (tbody ? tbody?.length:tbodyLength ) * 25 + 25 + "px";

    
    const rtlDataGridDirection = localStorage.getItem("DefaultLanguage") === "fa";
    let cellsWidth = useRef<any>([]);
    const SubIndexRef = useRef(operationSubIndex);
    let selectedIndex: any;
    const [flag, setFlag] = useState(false);

    let operationList = ["handleDelete", "handleEdit", "handleView"].filter(
      (e) => {
        if (e) {
          return e;
        }
      }
    );
    
    function toggleShowOperations(operationIndex) {
      setCurrentOperation(operationIndex);
      if (operationIndex === currentOperation || currentOperation === -1) {
        setShowOperations(!showOperations);
      } else setShowOperations(true);
    }

const handleDelete=(id)=>{
  let newTbody=[] as any
  if(tbody.length>DynamicObj?.tbodyLength){
    setTbody(()=>tbody.filter(item=>item.Id!=id))
    newTbody=tbody.filter(item=>item.Id!=id)

  }else{
    let filterItem=tbody.filter(item=>item.Id!=id)
    filterItem.push('')
    setTbody(filterItem)
    newTbody=filterItem

  }
  let data:any =[]
  JSON.parse(JSON.stringify(newTbody)).map(item=>{
    if(item.Id){
      delete item.Id ; 
      data.push(item) 

    }
    })
    handleRowsData && handleRowsData(data);

}

const handleEdit=(data)=>{
  setshowDataGridDataEntry(true)
  setEntryMode('edit')
  setEditedRow(data)
}

    function getTh(e, index) {
      e.stopPropagation();
      selectedIndex = index;
    }
    function setTh(e, index) {
      if (selectedIndex ||selectedIndex==0) {
        let putIndex = index;
        let selectIndex: any = selectedIndex;
        let arryHed = [...thead];
        let selectHed = arryHed[selectIndex];
        arryHed.splice(selectIndex, 1);
        arryHed.splice(putIndex, 0, selectHed);
        setThead(arryHed);
        setTimeout(() => {
          setFlag(!flag);
        }, 5);

      }
    }

    useEffect(() => {
      const newThead =
        theadData.length > 0
          ? theadData.filter(item => item.canUseInGrid !==false)
          : Array.from({ length: +theadLength }, (_, index) => {
              const existingColumn = thead[index];
              if (existingColumn) {
                return {
                  ...existingColumn,
                };
              } else {
                return {
                  title: generateUniqueColumnName(index),
                  typeName: "text",
                  icon: ["fas", "font"],
                  label: generateUniqueColumnName(index),
                  SystemKey: generateUniqueColumnName(index),
                  type: InputTypes.text,
                  backendType: "string",
                  ref: { current: trRef?.current?.children[index] },
                  //  theadSize:trRef?.current?.children[index]?.getBoundingClientRect().width
                };
              }
            });

      const newTbody = Array.from({ length: +tbodyLength }, (_, index) => {
        return "";
      });

      if (newThead?.length < theadLength) {
        const additionalColumns = Array.from(
          { length: theadLength - newThead?.length },
          (_, index) => ({
            title: generateUniqueColumnName(index),
            typeName: "text",
            icon: ["fas", "font"],
            label: generateUniqueColumnName(index),
            SystemKey: generateUniqueColumnName(index),
            type: InputTypes.text,
            backendType: "string",
          })
        );
        newThead.push(...additionalColumns);
      }

       setThead(newThead);
      setTbody(newTbody);
    }, [theadDataLengthVal,theadLengthVal,DynamicObj?.SystemKey]);

    const generateUniqueColumnName = (index: number): string => {
      let columnName = `column_${index + 1}`;
      let counter = 1;

      while (thead.some((col) => col.title === columnName)) {
        columnName = `column_${index + 1}-${counter}`;
        counter++;
      }

      return columnName;
    };

    let gridTemplateColumnsStyle: string[] = showOptionsRow ?   [
      "minmax(60px,60px)",
      ...thead?.map(() => "minmax(120px,auto)"),
    ] :
    thead?.map(() => "minmax(120px,auto)")
 
    function blurBtn(event) {
      event.currentTarget.parentElement?.parentElement?.blur();
    }
    const handleColumnEdit = (index: number) => {
      setSelectedColumn({
        index,
        label: thead[index].title,
        SystemKey: thead[index].SystemKey,
        title: thead[index].title,
        typeName: thead[index].typeName || "text",
        icon: thead[index].icon || ["fas", "font"],
        type: thead[index].type || InputTypes.text,
        backendType: thead[index].backendType || "string",
        Formula: thead[index].Formula || "string",
        Keywords: thead[index].Keywords ||[],
      });
      setShowEditModal(true);
    };

const handleDeleteColumn=(column)=>{
 setThead(thead.filter(item=>item.SystemKey!=column.SystemKey))
 
}

    function saveRowHandler(obj: any) {


      let objectAdd = false;
      const newTbody = tbody.map((item) => {
        if ((item == "" && !objectAdd) || item.Id==obj.Id) {
          objectAdd = true;
          return obj;
        } else {
          return item;
        }
      });
      if (!objectAdd) {
        newTbody.push(obj);
      }


      setTbody(newTbody);
      let data:any =[]
      JSON.parse(JSON.stringify(newTbody)).map(item=>{
        if(item.Id){
          delete item.Id ; 
          data.push(item) 

        }
        })
      handleRowsData && handleRowsData(data);
    }
    const handleColumnSave = (data: any) => { 

      if (selectedColumn) {
        const newThead = [...thead];
        newThead[selectedColumn.index] = {
          ...newThead[selectedColumn.index],
          ...data,
        };
        setThead(newThead);
      }
    };



    const toggleActiveRow = async (
      event: React.MouseEvent,
      rowIndex: number
    ) => {
      event.stopPropagation();
      myStateRef.current = rowIndex;
      selectedRowObjectCallback &&
        (await selectedRowObjectCallback(tbody[rowIndex], rowIndex, event));
    };

    const mouseDown = (index: number) => {
      setActiveIndex(index);
      activeIndexRef.current = index;
    };


    const mouseMove = useCallback(
      (e: MouseEvent) => {
        const gridColumns = thead.map((col, i) => {
          if (i === activeIndex) {
            if (tableElement.current) {
              const width = rtlDataGridDirection
                ? col.ref?.current?.getBoundingClientRect().right - e.clientX
                : e.clientX -
                  tableElement.current.getBoundingClientRect().left -
                  col.ref?.current?.offsetLeft;
              if (width >= minCellWidth) {
                cellsWidth.current[i] = width;
                return `${width}px`;
              }
            }
          }
          return `${col.ref?.current?.offsetWidth}px`;
        });

        if (tableElement.current) {
          tableElement.current.style.gridTemplateColumns =
            gridColumns.join(" ");
        }
      },
      [activeIndex, minCellWidth]
    );

    const mouseUp = useCallback(() => {
      removeListeners();
      setActiveIndex(null);
      setThead((prev) =>
        prev.map((item, index) => {
          return { ...item, theadSize: cellsWidth.current[index] };
        })
      );
      activeIndexRef.current = null;
    }, []);

    const removeListeners = useCallback(() => {
      window.removeEventListener("mousemove", mouseMove);
      window.removeEventListener("mouseup", mouseUp);
    }, [mouseMove, mouseUp]);

    useEffect(() => {
      if (activeIndex !== null) {
        window.addEventListener("mousemove", mouseMove);
        window.addEventListener("mouseup", mouseUp);
      }
      return () => removeListeners();
    }, [activeIndex, mouseMove, mouseUp]);

    useEffect(() => {

      if (!!thead.length) {
        handleDataGridFields && handleDataGridFields(thead);
      }
    }, [thead.length,thead]);
    useEffect(() => {
      if (!!tbodyData?.length) {
        
  if(tbodyData?.length<DynamicObj?.tbodyLength){
    const discount=DynamicObj?.tbodyLength-tbodyData?.length
    let newTbody=tbodyData
    for(let i=0;i<discount;i++){
      newTbody.push('')
    }
    setTbody(newTbody)
  }else{
    setTbody(tbodyData)

  }
      }
    }, [tbodyData]);




    

    return (
      <>
        {showDataGridDataEntry && (
          <ModalForm
            title={ trans("DataEntry")+" : "+ DynamicObj?.Title}
            onHide={() => {
              setshowDataGridDataEntry(false);
            }}
            show={showDataGridDataEntry}
          >
            <DataGridDataEntry
              saveRowhandler={saveRowHandler}
              onHide={() => {
                setshowDataGridDataEntry(false);
              }}
              GridFields={JSON.parse(DynamicObj?.DataGridFields)?.inputList?JSON.parse(DynamicObj?.DataGridFields)?.inputList:JSON.parse(DynamicObj?.DataGridFields)}
              mode={mode}
              gridKey={""}
              EntryMode={EntryMode}
              editedRow={editedRow}
              condition={JSON.parse(DynamicObj?.DataGridFields)?.condition?JSON.parse(DynamicObj?.DataGridFields)?.condition:null}
              formula={JSON.parse(DynamicObj?.DataGridFields)?.formula?JSON.parse(DynamicObj?.DataGridFields)?.formula:null}
            />
          </ModalForm>
        )}
        <div></div>
        <div className="simple-grid-wrapper">
          <table
            className={`simple-grid ${disabled ? "disabled" : ""}`}
            ref={tableElement}
            style={{ gridTemplateColumns: gridTemplateColumnsStyle?.join(" "),height:`${(30*DynamicObj?.tbodyLength)+5}px`,maxHeight: `${(30*DynamicObj?.tbodyLength)+5}px`,overflowY:'auto'}}
          >
            <thead className="simple-grid__thead">
              <tr className="simple-grid__tr" ref={trRef}>
            {  (showOptionsRow) &&  <td
                  className={`simple-grid__header-cell ${
                    disabled ? "disabled" : ""
                  }`}
                  // onDoubleClick={() => !disabled && handleColumnEdit(index)}
                  // ref={column.ref}
                >
                  {mode!="view"&& 
                  
                  <Button
                    Icon={true}
                    value={
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setEntryMode('create')
                          setshowDataGridDataEntry(true);
                        }}
                        className="checkButton d-flex align-items-center justify-content-center"
                      >
                        {" "}
                        <FontAwesomeIcon icon={[ICON_TYPE, "plus"]} size="2x" />
                      </button>
                    }
                    btnType="primary"
                  />
                  
                  }
                  {resizeOption && (
                    <div className={`simple-grid__resize-handle h-100 idle`} />
                  )}
                </td>}

                {thead?.map((column: any, index) => (
                  <OverlayTrigger
                    key={(column?.title?column?.title:column?.label) + index}
                    placement="top"
                    delay={{ show: 600, hide: 0 }}
                    overlay={
                      <Tooltip id={`tooltip-${column?.title?column?.title:column?.label}`}>
                      {column?.label?column?.label:column?.title} ({trans(column?.typeName || "text")})
                      </Tooltip>
                    }
                  >
                    <th
                      className={`simple-grid__header-cell ${
                        disabled ? "disabled" : ""
                      }`}
                      onDoubleClick={() => !disabled && handleColumnEdit(index)}
                      ref={column?.ref}
                    >
                      
                      <div style={{paddingLeft:"20px"}} className="d-flex align-items-center justify-content-between">
                      <div 
                          style={{cursor:"pointer", width:"100%"}}
                         onMouseDown={(e) => {
                            getTh(e, index);
                          }}
                          onMouseUp={(e) => {
                            setTh(e, index);
                          }}                     
                      className="d-flex align-items-center  gap-2 ml-2">
                        {column?.icon&&
                        <FontAwesomeIcon icon={column?.icon} />
                        }
                        <span  

                           className="simple-grid__header-cell-span showDots d-block" >
                          {column?.label?column?.label:column?.title}
                        </span>
                      </div>
                      {showSetting?

                      <div className="d-flex ">
                        <FontAwesomeIcon className="mx-1" style={{cursor:"pointer"}} onClick={(e)=>{!disabled && handleDeleteColumn(column)}} icon={["fas","trash"]} />
                        <FontAwesomeIcon style={{cursor:"pointer"}} onClick={(e)=>{!disabled && handleColumnEdit(index)}} icon={["fas","gears"]} />
                      </div>

                      :<></>}

                       
                      </div>
                      {true && (
                        <div
                          onMouseDown={() => mouseDown(index)}

                          style={{ height: `${tableHeight} !important` }}
                          className={`simple-grid__resize-handle h-100 resizeDisabled ${
                            activeIndex === index ? "active" : "idle"
                          }`}
                        />
                      )}
                    </th>
                  </OverlayTrigger>
                ))}
              </tr>
            </thead>
            <tbody className="simple-grid__tbody">
              {tbody&&tbody.map((row: any, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={`simple-grid__tr ${
                    myStateRef.current === rowIndex ? "active" : ""
                  }`}
                  onClick={(event) => toggleActiveRow(event, rowIndex)}
                >
                  {!createTableInDataCollectionTab && (
                    <>
                  {showOptionsRow &&  
                  <td className="simple-grid__body-cell">
                    {mode!="view"&&
                        <button
                          id={"Operation" + rowIndex}
                          tabIndex={-1}
                          type="button"
                          className="operations__trigger-btn"
                          onClick={(e) => {
                            setShowOptions(true);
                          }}
                          onFocus={(e) => {
                            if (
                              window.innerHeight -
                                e.target.getBoundingClientRect().top <
                              ([].length + 2) * 25
                            ) {
                              setOperationPosition(([].length + 2) * 25);
                            } else {
                              setOperationPosition(0);
                            }
                            toggleShowOperations(rowIndex);
                            SubIndexRef.current = 0;
                          }}
                          onBlur={() => {
                            toggleShowOperations(rowIndex);
                            setShowOperations(false);
                            SubIndexRef.current = -3;
                          }}
                        >
                    {  row.Id &&    <FontAwesomeIcon icon={["fas", "ellipsis-v"]} />}

                          <div
                            style={{
                              zIndex: "10",
                              top: `${
                                rowIndex * 25 + 40 - operationPosition
                              }px`,
                            }}
                            className={`operations__operations-icons pt-1 ${
                              showOperations &&
                              rowIndex === currentOperation &&
                              SubIndexRef.current !== -3
                                ? ""
                                : "d-none"
                            }`}
                          >
                            <div
                              className={`operations__operations-icon-wrapper ${
                                operationList.indexOf("delete") ===
                                operationSubIndex
                                  ? "subFocos"
                                  : " "
                              }`}
                              onClick={blurBtn}
                            >
                              <div
                                className="operations__operations-icon-wrapper"
                                onClick={() => {
                                  handleDelete(row.Id);
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={[ICON_TYPE, "trash-alt"]}
                                  className="text-primary"
                                />
                                <p>{trans("Delete")}</p>
                              </div>
                            </div>
                          
                            <div
                              className={`operations__operations-icon-wrapper ${
                                operationList.indexOf("edit") ===
                                operationSubIndex
                                  ? "subFocos"
                                  : " "
                              }`}
                              onClick={blurBtn}
                            >
                              <div
                                className="operations__operations-icon-wrapper"
                                onClick={() => handleEdit(row)}
                              >
                                <FontAwesomeIcon
                                  icon={[ICON_TYPE, "edit"]}
                                  className="text-primary"
                                />
                                <p>{trans("Edit")}</p>
                              </div>
                            </div>
                          </div>
                        </button>
                    
                    }
                      </td>}
                      {thead.map((column, cellIndex) => (
                        <td key={cellIndex} className="simple-grid__body-cell px-1">
                       {
                          column?.typeName=='date' ||  column?.typeName=='time' ?
                          
                          row[column.SystemKey]? new DateObject(row[column.SystemKey])
                          .convert(persian, persian_fa)
                          .format(column?.typeName=='time' ? "YYYY/MM/DD HH:mm":'YYYY/MM/DD'):null
                          :
                          column?.typeName == 'RadioButton' || column?.typeName == 'radio'?<>
                    {     column?.Keywords?.find(item=>item.SystemKey==row[column.SystemKey])?.name}
                          
                         
                          </>
                          :
                          column?.typeName=='checkBox'?
                        row[column.SystemKey]==true || row[column.SystemKey]=='true'?
                          <div className="w-100 data-grid__check-icon">
                                                                          <FontAwesomeIcon
                                                                            icon={[
                                                                              ICON_TYPE,
                                                                              "check-square",
                                                                            ]}
                                                                          />
                                                                        </div>
                        :
<div className="w-100 data-grid__check-icon">
                                                  <FontAwesomeIcon
                                                    icon={["far", "square"]}
                                                  />
                                                </div>
                          :
                          (row[column.SystemKey+"Description"] ? row[column.SystemKey+"Description"]: row[column.SystemKey])}

                        </td>
                      ))}
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>

          {showEditModal && selectedColumn && (
            <ColumnEditModal
              show={showEditModal}
              onHide={() => setShowEditModal(false)}
              onSave={handleColumnSave}
              initialTitle={selectedColumn.title}
              initialType={selectedColumn.typeName}
              initialSystemKey={selectedColumn.SystemKey}
              initialFormula={selectedColumn.Formula}
              selectedColumn={selectedColumn}
            />
          )}
        </div>
      </>
    );
  }
);
